/**
 * @class Unit
 */
export default class Unit {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  code
     * @param {Boolean} isGravimetric
     */
    constructor(id, name, code, isGravimetric) {
        this._id = id;
        this._name = name;
        this._code = code;
        this._isGravimetric = isGravimetric;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Unit");
        }

        if (typeof this._code !== "string") {
            throw new Error("Invalid datatype of code - Unit");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get code() {
        return this._code;
    }

    /**
     * @param {String} code
     */
    set code(code) {
        this._code = code;
    }

    /**
     * @return {Boolean}
     */
    get isGravimetric() {
        return this._isGravimetric;
    }

    /**
     * @param {Boolean} isGravimetric
     */
    set isGravimetric(isGravimetric) {
        this._isGravimetric = isGravimetric;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Unit (" + this._id + ")";
    }
}
